import { Component, Input, OnInit } from '@angular/core';
import PasswordHelper from 'src/app/core/helpers/password.helper';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent implements OnInit {
  @Input() value!: string;
  passwordHelper = PasswordHelper;
  currentPasswordStrength: any;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.value){
      this.currentPasswordStrength = this.passwordHelper.checkPasswordStrength(this.value);
    }
  }
}
